<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 class="mb-5">
        <v-btn-toggle class="width-100" v-model="selectedType" mandatory>
          <v-btn class="btn-filter" flat value="presupuesto">
            Presupuestos
          </v-btn>
          <v-btn class="btn-filter" flat value="factura">
            Facturas
          </v-btn>
          <!-- <v-btn class="btn-filter" flat value="ticket">
            Tickets
          </v-btn> -->
        </v-btn-toggle>
      </v-flex>
    </v-layout>
    <!-- Data table with series -->
    <v-data-table
      ref="openBillingSerieTable"
      v-model="selectedItems"
      :loading="loading"
      :headers="headers"
      :items="series"
      :pagination.sync="seriesPagination"
      :rows-per-page-items="[10, 20, 30, 50, 100]"
      :total-items="seriesPagination.totalItems"
      select-all
    >
      <template v-slot:no-data>
        <v-alert :value="true" color="info" icon="info" outline>
          {{ $t('Todavía no has añadido ninguna serie :(') }}
        </v-alert>
      </template>
      <template v-slot:headers="props">
        <tr>
          <!--          <th v-if="props.headers.length > 0" class="text-xs-center">-->
          <!--            <v-checkbox-->
          <!--              v-model="selectAllRows"-->
          <!--              @change="selectAllTableRows()"-->
          <!--              primary-->
          <!--              hide-details-->
          <!--            ></v-checkbox>-->
          <!--          </th>-->
          <th></th>
          <template v-for="header in props.headers">
            <th
              :key="`th_${header.value}`"
              :class="[
                'text-xs-center',
                header.sortable ? 'column sortable' : '',
                seriesPagination.descending ? 'desc' : 'asc',
                header.value === seriesPagination.sortBy ? 'active' : '',
              ]"
              @click="header.sortable ? changeSort(header.value) : null"
            >
              <v-icon v-if="header.sortable" small>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </template>
          <th v-if="props.headers.length > 0" class="text-xs-center">ACCIONES</th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr>
          <!--          <td>-->
          <!--            <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>-->
          <!--          </td>-->
          <td class="pa-0 text-xs-center">
            <v-btn v-if="props.item['default']" flat icon color="green">
              <v-icon>check</v-icon>
            </v-btn>
          </td>
          <td v-for="header in headers" :key="header.value" class="text-xs-center">
            {{ props.item[header.value] }}
          </td>
          <td class="text-xs-center">
            <v-icon small class="mr-2" @click="editSerie(props.item)">
              edit
            </v-icon>
            <v-icon :disabled="props.item['used']" small @click="deleteSerie(props.item)">
              delete
            </v-icon>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import apiCtrl from '@/services/api/abstract/abstract-api';

export default {
  name: 'OpenBillingSerieTable',
  components: {},
  props: ['search'],
  data() {
    return {
      series: [],
      selectedItems: [],
      selectAllRows: false,
      loading: false,
      headers: [],
      seriesPagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10, // -1 for All",
        sortBy: '',
        totalItems: 0,
      },
      sortTable: false,
      selectedType: 'factura',
    };
  },
  mounted() {
    this.getBillingSeries();
  },
  computed: {
    currentPage() {
      return this.seriesPagination.page;
    },
    perPage() {
      return this.seriesPagination.rowsPerPage;
    },
    sortBy() {
      return this.seriesPagination.sortBy;
    },
    descending() {
      return this.seriesPagination.descending;
    },
    billingProfileId() {
      return this.$store.getters.currentOpenbillingProfileId;
    },
    clavedat() {
      return this.$store.state.clavedat;
    },
  },
  methods: {
    getBillingSeries() {
      this.loading = true;
      const config = {
        params: {
          page: this.seriesPagination.page,
          per_page: this.seriesPagination.rowsPerPage,
          sort_by: this.seriesPagination.sortBy,
          descending: this.seriesPagination.descending,
          type: this.selectedType,
        },
      };
      apiCtrl
        .get(`/openbilling/${this.clavedat}/series/list`, config)
        .then(res => {
          this.series = res.data.data;
          this.headers = res.data.dataTable.headers;
          this.seriesPagination = {
            descending: this.seriesPagination.descending,
            page: this.seriesPagination.page,
            rowsPerPage: Number(res.data.meta.per_page), // -1 for All",
            sortBy: this.seriesPagination.sortBy,
            totalItems: Number(res.data.meta.total),
          };
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    selectAllTableRows() {
      if (
        this.selectedItems.length === 0 ||
        (this.selectedItems.length >= 1 && this.selectedItems.length < this.series.length)
      ) {
        let selected = [];
        this.series.forEach(item => {
          selected.push(item);
        });
        this.selectedItems = selected;
      } else if (this.selectedItems.length === this.series.length) {
        if (this.selectAllRows) {
          this.selectedItems = this.series;
        } else {
          this.selectedItems = [];
        }
      }
    },
    changeSort(column) {
      if (this.seriesPagination.sortBy === column) {
        this.seriesPagination.descending = !this.seriesPagination.descending;
      } else {
        this.seriesPagination.sortBy = column;
        this.seriesPagination.descending = false;
      }
    },
    editSerie(serie) {
      this.$emit('on-edit-serie', serie);
    },
    deleteSerie(serie) {
      this.$emit('on-delete-serie', serie);
    },
  },
  watch: {
    selectedType: function() {
      this.$emit('on-change-type', this.selectedType);
      this.getBillingSeries();
    },
  },
};
</script>

<style scoped>
.btn-filter {
  padding: 1.5rem 3rem;
}
.width-100 {
  width: 100%;
}
</style>
